/**
 * Created by Roman T on 9/11/2017.
 * Modified by Kim J on 2017-11-30 (card 785)
 */
var DetailPaymentEuCheckController = (function () {
    function DetailPaymentEuCheckController(topic, $scope, socket, env) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.env = env;
        this.comp = 'eu_check';
        this.visibleEu = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // if (data.indexOf(this.comp) > 1) {
            // Temp code, make it better
            // #1774, this code changes editable state of the component based on invoice/submitted flags values updates in topic
            // flags are updated in ation-menu-component.ts
            // for NA end user check logic is the same on this step as for other countries on invoice requested step (flag === 0)
            // this is because users can get to this step after batch process and they need possibility to update end user check
            if (!((_this.topic.topic.iot === 'North America IOT' && _this.topic.topic.invoice_flags && _this.topic.topic.invoice_flags.submitted === true) ||
                (_this.topic.topic.iot !== 'North America IOT' && _this.topic.topic.invoice_flags && _this.topic.topic.invoice_flags.requested === true))) {
                _this.topic.editableComponents.eu_check = { editable: true, editMode: false, socket: '' };
            }
            else {
                _this.topic.editableComponents.eu_check = { editable: false, editMode: false, socket: 'Not Editable' };
            }
            _this.edit = _this.topic.getEditComponent(_this.comp);
            //   }
        });
        this.eu_options = ['Yes', 'No'];
    }
    DetailPaymentEuCheckController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailPaymentEuCheckController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                var updateObject = {
                    data: {
                        eu_check: {
                            add: true,
                            data: this.topic.temp.eu_check
                        }
                    },
                    id: this.topic.topic._id,
                    type: ['eu_check']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailPaymentEuCheckController.prototype.toggleEu = function () {
        this.visibleEu = !this.visibleEu;
    };
    DetailPaymentEuCheckController.$inject = ['topic', '$scope', 'socket', 'env'];
    return DetailPaymentEuCheckController;
}());
var DetailPaymentEuCheckComponent = (function () {
    function DetailPaymentEuCheckComponent() {
        this.templateUrl = 'detail-eu-check.html';
        this.controllerAs = 'vm';
        this.controller = DetailPaymentEuCheckController;
    }
    return DetailPaymentEuCheckComponent;
}());
angular
    .module('application')
    .component('detailEuCheck', new DetailPaymentEuCheckComponent());

//# sourceMappingURL=detail.payment.eu.check.component.js.map
